export const eligibleCountries = {
  userCountryCode: "DK",
  countries: [
    { value: "DK", label: "🇩🇰 Denmark" },
    { value: "NO", label: "🇳🇴 Norway" },
    { value: "SE", label: "🇸🇪 Sweden" },
    { value: "FI", label: "🇫🇮 Finland" },
  ],
  userSelectValue: { value: "DK", label: "🇩🇰 Denmark" },
};
